import { useState, useEffect } from "react";
import { Box, InputBase, Typography, IconButton, Tooltip } from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseFestivalManagment } from "./UseFestivalManagment";
import { useLocation, useNavigate } from "react-router-dom";
import { UseMyPC } from "../../hooks/UseMyPC";
import CustomPagination from "../../components/CustomPagination";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { deCapitalizeFirstLetter } from "../../util/Utils";
import { rsGotoLast, rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import DeleteRow from "../../components/DeleteRow";

export default function FestivalManagment() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const navigate = useNavigate();
  const { getFestivalList, deleteFestivalList } = UseFestivalManagment();
  const {
    myPc,
    goToLastPage,
    goToFirstPage,
    updatePage,
    updateSort,
    setScrollTo,
    refresh,
  } = UseMyPC("Id", "Desc");
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [festivalRes, setFestivalRes] = useState();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [searchState, setSearchState] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [search, setSearch] = useState(
    location.state && location.state.search ? location.state.search : ""
  );

  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });

  function handleSearch(value) {
    setScrollTo(undefined);
    location.state = null;
    setSearch(value);
  }

  useEffect(() => {
    if (
      myPc.page === 0 ||
      (location.state && location.state && location.state.isBack)
    ) {
      return;
    }
    setProgress(true);

    getFestivalList(
      myPc,
      search,
      (festivals) => {
        if (msGotoLast) {
          setMsGotoLast(false);
          goToLastPage(festivals.totalPage);
          return;
        }
        setFestivalRes(festivals);
      },
      true
    );
  }, [myPc]);

  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
    }
    if (search.length > 0 && !location.state) {
      goToFirstPage();
    } else {
      refresh();
    }
  }, [search]);

  const newFunc = () => {
    return navigate("/festivalmanagment/addFestival", {
      state: {
        myPc: myPc,
        search: search,
      },
    });
  };

  const columns = [
    {
      field: "rowNO",
      width: 80,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
    },
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "id",
      headerAlign: "center",
      hide: true,
    },
    {
      field: "title",
      headerName: "عنوان",
      width: 200,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{ whiteSpace: "normal", textAlign: "center" }}
          >
            {cellValues.row.title}
          </Typography>
        );
      },
    },
    {
      field: "shamsiStartDate",
      headerName: "شروع",
      width: 110,
      align: "center",
      headerAlign: "center",
    },

    {
      field: "shamsiEndDate",
      headerName: "پایان",
      width: 110,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "state",
      headerName: "وضعیت",
      width: 130,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "عملیات",
      sortable: false,
      width: 110,
      headerAlign: "center",
      align: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <Box sx={{ display: "flex", gap: 1 }}>
            <Tooltip title="Delete">
              <IconButton
                sx={{ p: 0.5 }}
                onClick={() => {
                  setDeleteState({
                    show: true,
                    name: cellValues.row.title,
                    id: cellValues.row.id,
                  });
                }}
              >
                <DeleteIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Edit">
              <IconButton
                sx={{ p: 0.5 }}
                onClick={() => {
                  setScrollTo(cellValues.api.getScrollPosition());

                  return navigate("/festivalmanagment/editFestival", {
                    state: {
                      model: cellValues.row,
                      myPc: myPc,
                      search: search,
                      id: cellValues.row.id,
                    },
                  });
                }}
              >
                <EditIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    },
    {
      field: "search",
      width: 200,
      sortable: false,
      headerAlign: "center",
      renderHeader: (cellValues) => {
        return (
          <Box
            sx={{ border: "1px solid #d3d3d3", borderRadius: 1 }}
            width="auto"
            display="flex"
            justifyContent="flex-start"
          >
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="جستجو"
              value={searchState}
              inputProps={{ "aria-label": "search" }}
              onChange={(evt) => {
                if (evt.target.value == "") {
                  handleSearch("");
                }
                setSearchState(evt.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch(searchState);
                }
              }}
            />
          </Box>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "مارکتینگ",
        childs: [{ name: msActiveMenu.pageTitle, url: "/festivalmanagment" }],
      }}
    >
      {festivalRes ? (
        <DataGrid
          className="ltr-grid"
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          pageSize={festivalRes.pageCondition.pageCount}
          rows={festivalRes && festivalRes.items ? festivalRes.items : []}
          paginationMode="server"
          page={festivalRes.pageCondition.page - 1}
          onPageChange={(page) => {
            updatePage(page + 1);
          }}
          rowCount={
            festivalRes?.pageCondition.totalItemCount
              ? festivalRes.pageCondition.totalItemCount
              : 1
          }
          enableRangeSelection={true}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          componentsProps={{
            pagination: {
              scrollTo: myPc.scrollTo,
              newFunc: newFunc,
              isLtr: true,
              rowCount: festivalRes?.pageCondition.totalItemCount
                ? festivalRes.pageCondition.totalItemCount
                : "",
            },
          }}
          initialState={{
            sorting: {
              sortModel: [
                {
                  field: deCapitalizeFirstLetter(myPc.sortColumn),
                  sort: deCapitalizeFirstLetter(myPc.sortOrder),
                },
              ],
            },
            pagination: {
              page: myPc.page,
            },
          }}
          onSortModelChange={(model) => {
            updateSort(model[0].field, model[0].sort == "asc" ? "asc" : "desc");
          }}
          sortingOrder={["desc", "asc"]}
          sortingMode="server"
          sx={{
            "& .MuiDataGrid-cell:focus": {
              outline: "none",
            },
            "&  .MuiDataGrid-columnHeader:focus-within": {
              outline: "none",
            },
            "&  .MuiDataGrid-cell:focus-within ": {
              outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
            },
            "& .muirtl-hnxuso-MuiDataGrid-root .MuiDataGrid-cell:focus-within":
              {
                outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
              },
            "& .MuiDataGrid-cell:hover": {
              opacity: "80%",
              cursor: "pointer",
            },
            "& .MuiDataGrid-virtualScrollerRenderZone": {
              width: "100% !important",
            },
            "& .red": {
              backgroundColor: "#ff9c9c !important",
            },
            "& .pink": {
              backgroundColor: "#ffdbdb !important",
            },
            "& .orange": {
              backgroundColor: "#FFC36E !important",
            },
          }}
          getRowClassName={(params) => {
            if (params.row.stateID == 1) {
              return "orange";
            } else if (params.row.stateID == 2) {
              return "red";
            }
          }}
        />
      ) : (
        <ProgressCom></ProgressCom>
      )}

      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={"جشنواره"}
        callback={() => {
          setProgress(true);
          deleteFestivalList(deleteState.id, () => {
            refresh();
          });
        }}
      ></DeleteRow>
    </Detail>
  );
}
